import { SentryContextKeys } from '@core/const';
import { ErrorEvent } from '@sentry/core';

export function isErrorExcluded(event: ErrorEvent): boolean {
  const tags = event.tags ?? {};
  const extra = event.extra ?? {};

  // Ошибки со статусом 0
  if (tags[SentryContextKeys.ResponseStatus] === 0) {
    return true;
  }

  // Ошибки со статусом 404
  if (tags[SentryContextKeys.ResponseStatus] === 404) {
    return true;
  }

  // Ошибки с протухшим токеном
  if (extra[SentryContextKeys.ResponseErrorType] === 'InvalidTokenError') {
    return true;
  }

  return false;
}
